import {
    Alert,
    Button,
    Dropdown,
    ExclamationTriangleIcon,
    Flex,
    InputLabel,
    Loader,
    TextArea,
} from "@fluentui/react-northstar";
import React from "react";
import StepTitle from "../../../../components/StepsTitle/StepTitle";
import { Controller } from "react-hook-form";
import DropzoneDocuments from "../../components/dropzoneDocuments/DropzoneDocuments";
import FooterActionButtons from "../../components/footer/FooterActionButtons";
import useLogicJustification from "../../hooks/useLogicJustification";
import { ErrorMessage } from "../../../../common/styles";

const StepJustificatif = () => {
    const { query, form, query_list_reasons, mutation, dropzone, navigation } =
        useLogicJustification();

    if (query.isLoading || query.isFetching || query_list_reasons.isLoading) {
        return <Loader label="Chargement ..." />;
    }

    if (!query.data) {
        return (
            <Alert
                content="Une erreur est survenue ! Veuillez réessayer plus tard !"
                icon={<ExclamationTriangleIcon />}
                danger
            />
        );
    }

    // default values
    const index_of_default_reason = query_list_reasons.formated_data.findIndex(
        (el) => el.id === query.data?.reason.value
    );
    return (
        <Flex fill column space="between" gap="gap.large">
            <Flex column gap="gap.large">
                <StepTitle title="Motifs et justificatifs" step_number={2} />
            </Flex>

            <Flex fill gap="gap.large" column>
                {/* dropdown */}
                <Flex fill column>
                    <InputLabel content="Type de motif " required />
                    <Controller
                        control={form.control}
                        name="reason"
                        rules={{
                            required: {
                                value: true,
                                message: "Ce champ est obligatoire",
                            },
                        }}
                        defaultValue={
                            index_of_default_reason === -1
                                ? null
                                : query_list_reasons.formated_data.at(
                                      index_of_default_reason
                                  )
                        }
                        render={({
                            field: { onChange, onBlur, value, ref, name },
                        }) => {
                            const format =
                                query_list_reasons.formated_data.find(
                                    (item) => item.id === value?.id
                                );
                            let value_format = format;
                            if (!format?.id) {
                                value_format =
                                    index_of_default_reason === -1
                                        ? null
                                        : query_list_reasons.formated_data.at(
                                              index_of_default_reason
                                          );
                            }

                            return (
                                <Dropdown
                                    items={query_list_reasons.formated_data}
                                    value={value_format}
                                    placeholder="Choisir parmi la sélection"
                                    name={name}
                                    ref={ref}
                                    onChange={(_, i) => {
                                        return onChange(i.value);
                                    }}
                                    onBlur={onBlur}
                                    getA11ySelectionMessage={{
                                        onAdd: (item) =>
                                            `${item} has been selected.`,
                                    }}
                                    inverted
                                    checkable
                                    error={form.formState.errors.reason}
                                    styles={{
                                        width: "100%",
                                    }}
                                />
                            );
                        }}
                    />
                    {form.formState.errors.reason && (
                        <ErrorMessage
                            content={form.formState.errors.reason.message}
                        />
                    )}
                </Flex>
                {/* Description */}
                <Flex column>
                    <InputLabel content="Description" />
                    <Controller
                        control={form.control}
                        name="reason_description"
                        defaultValue={query.data?.reason?.description || ""}
                        render={({ field: { onChange, onBlur, value } }) => (
                            <TextArea
                                fluid
                                inverted
                                rows={6}
                                value={value}
                                onChange={(_, i) => {
                                    return onChange(i.value);
                                }}
                            />
                        )}
                    />
                </Flex>
                {/* dropzone */}
                <Flex>
                    <DropzoneDocuments
                        onSuccessUploadFile={dropzone.setFiles}
                        default_files={dropzone.files}
                    />
                </Flex>
            </Flex>
            {/* FOOTER */}
            <FooterActionButtons
                enableButtonNextStep={form.formState.isValid}
                enableButtonBackStep={true}
                onClickNextStep={(e) => {
                    e.preventDefault();
                    return form.handleSubmit((data) =>
                        form.onSubmit(data, dropzone.files)
                    )();
                }}
                onClickBackStep={navigation.buttonBackStep}
                isLoadingNextStep={mutation.isLoading}
            />
        </Flex>
    );
};

export default StepJustificatif;
